import DateFilters from "@/constants/filters/date";

const defaultState = {
  pendingServices: [],
  pendingFilterClient: "",
  date: { value: DateFilters.NUM_THIS_WEEK, text: DateFilters.THIS_WEEK }
};

export default defaultState;
